module.exports = __webpack_public_path__ + "img/1.a3b2c4a3.png";